
import React, { ReactNode } from 'react';

import { Container } from './styles';

type ChieldrenType = {
    children: ReactNode
}

const Content: React.FC<ChieldrenType> = ({ children }) => (
    <Container>
        {children}
    </Container>
);

export default Content;
